// 테스트 관련 코드, 추후 삭제 예정
/**
 * 개발자 메뉴 — 테스트/약관확인/가이드확인/UI표준 진입 허브
 *
 * LNB에서 제거된 임시 개발용 화면들의 진입점을 한곳에 모은 화면.
 * TopBar 우측 숨김 버튼(스튜디오 홈)에서만 진입 가능.
 */
import { useNavigate } from 'react-router';
import { Button } from '@indipia/ui-core';

// external: SPA 라우트가 아니라 dev 서버가 직접 서빙하는 정적 가이드 → 새 탭으로 하드 이동
// devOnly: 프로덕션 빌드에 라우트가 없는 개발용 화면
const ITEMS: { label: string; desc: string; to: string; external?: boolean; devOnly?: boolean }[] = [
  { label: '테스트',     desc: '공통 컴포넌트 개발자 가이드 · 라이브 데모',       to: '/test' },
  { label: '약관확인',   desc: '약관 유형별 최신 약관 렌더 확인',                to: '/test/terms' },
  { label: '가이드확인', desc: '에이전트별 가이드(TM_AGENT.AGENT_GUIDE) 렌더 확인',   to: '/test/guide' },
  { label: '상담사채팅', desc: '상담 채팅 실시간 연동 테스트(고객 쪽, 핸드오프 가정)', to: '/test/support-chat' },
  { label: 'UI 표준',    desc: 'D-07 디자인 시스템 뷰어',                       to: '/ui-standard' },
  { label: '에이전트 컴포넌트', desc: 'ui-core 미등록 에이전트 로컬 컴포넌트 — 라이브 샘플 · 판정 · 사용 화면', to: '/agent-components', devOnly: true },
  {
    label: '가이드 전체 모음',
    desc: 'web · mobile 디자인 가이드 허브 (개발 서버 전용 · 새 탭)',
    to: '/guides',
    external: true,
  },
];

// external 항목(가이드)은 프로덕션 빌드에서 서빙되지 않으므로 숨긴다.
// ⚠ import.meta.env.DEV 를 쓰면 안 된다 — vite build 에서는 --mode development 여도 항상 false 라
//    배포 dev 서버에서까지 항목이 사라진다. MODE 로 판단해야 dev 빌드에서는 노출된다.
//    (guides-plugin 의 emit 조건 `config.mode === 'production'` 과 같은 기준)
const VISIBLE_ITEMS = ITEMS.filter(
  (item) => !(item.external || item.devOnly) || import.meta.env.MODE !== 'production',
);

export function DevMenuPage() {
  const navigate = useNavigate();

  return (
    <div className="mx-auto max-w-2xl space-y-4 p-6">
      <div className="rounded-xl border border-warning bg-surface-subtle px-4 py-3">
        <p className="text-xs font-semibold text-warning">개발자 메뉴 — 프로덕션 미노출</p>
        <p className="mt-0.5 text-xs text-text-secondary">
          테스트 / 약관확인 / 가이드확인 / UI 표준 / 가이드 모음 진입 허브
        </p>
      </div>

      <div className="space-y-2">
        {VISIBLE_ITEMS.map((item) => (
          <div
            key={item.to}
            className="flex items-center justify-between rounded-xl border border-border-default bg-white p-4"
          >
            <div>
              <p className="text-sm font-semibold text-text-primary">{item.label}</p>
              <p className="mt-0.5 text-xs text-text-secondary">{item.desc}</p>
            </div>
            <Button
              variant="secondary"
              size="sm"
              onClick={() =>
                item.external ? window.open(item.to, '_blank', 'noopener') : navigate(item.to)
              }
            >
              {item.external ? '새 탭' : '이동'}
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}
